import React from 'react';
import { Stack, Typography } from '@mui/material';
import { JournalStatus } from '../../../types/finance';
import JournalStatusChip from '../journal/JournalStatusChip';

/** A posted line's description: what it was, whether it was reversed (or is a reversal), and who entered it. */
const MovementDescription: React.FC<{
  text: string;
  status: JournalStatus;
  isReversal: boolean;
  entryId: string;
  createdByName: string | null;
  maxWidth?: number;
}> = ({ text, status, isReversal, entryId, createdByName, maxWidth = 300 }) => (
  <>
    <Stack direction="row" spacing={1} alignItems="center">
      <Typography variant="body2" noWrap sx={{ maxWidth }} title={text}>{text}</Typography>
      {(isReversal || status === 'REVERSED') && <JournalStatusChip entry={{ status, reversesEntryId: isReversal ? entryId : null }} />}
    </Stack>
    {createdByName && <Typography variant="caption" color="text.secondary">{createdByName}</Typography>}
  </>
);

export default MovementDescription;
